import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockSettings } from 'venn-state';
import type { ErrorWrapper } from './errorWrapperTypes';
import { StyledErrorState } from '../StyledErrorState';
import { isHoldingsFixedIncomeBlock, useDebugValue } from 'venn-utils';
import { useHoldings } from '../../logic/useHoldings';

export const FixedIncomeErrorWrapper: ErrorWrapper = ({ blockId, children }) => {
  const blockSetting = useRecoilValue(blockSettings(blockId));
  const { data } = useHoldings(blockId);

  const forceError = useDebugValue('debugBlockErrorState') === 'FixedIncomeSubjects';

  const allSubjectsNoFixedIncome = !!data?.breakdowns?.every((breakdown) => breakdown.percentageCovered === 0);

  if (forceError || (isHoldingsFixedIncomeBlock(blockSetting.customBlockType) && allSubjectsNoFixedIncome)) {
    return (
      <StyledErrorState
        selectedRefId={blockId}
        header="This block only supports subjects with fixed income positions"
        message="No fixed income positions were found in the assigned subjects."
      />
    );
  }

  return children;
};
